import { service } from '@ember/service';
import Component from '@glimmer/component';

import type { Service } from 'webapp-types';
import { GoalStatus } from 'webapp/enums/enums';

import CommonUiIconComponent from 'webapp/components/common/ui-icon';

interface GoalStatusComponentInterface {
	Args: {
		status: GoalStatus | null;
		timeLeftText?: string;
		size?: 'small' | 'large';
	};
}
export default class GoalStatusComponent extends Component<GoalStatusComponentInterface> {
	@service('model-manager/goals') declare mmGoalsService: Service.ModelManager.Goals;

	get isCompleteAndNoTimeLeft() {
		return this.mmGoalsService.getIsGoalComplete(this.status) || !this.args.timeLeftText;
	}

	get status() {
		return this.args.status;
	}

	get statusText() {
		return this.mmGoalsService.getStatusText(this.status);
	}

	get iconName() {
		return this.mmGoalsService.getIconName(this.status);
	}

	get iconSize(): IconSize {
		return this.args.size === 'large' ? 'md' : 'sm';
	}

	get statusTextLowercase() {
		return this.statusText.toLowerCase();
	}

	get sizeClass() {
		return this.args.size === 'large' ? 'size-large' : 'size-small';
	}

	<template>
		{{#if this.isCompleteAndNoTimeLeft}}
			<div class="status {{this.sizeClass}} status--{{this.statusTextLowercase}}">
				<CommonUiIconComponent @name={{this.iconName}} @size={{this.iconSize}} />
				{{this.statusText}}
			</div>
		{{else if @timeLeftText}}
			<div class="timeleft">{{@timeLeftText}}</div>
		{{/if}}
	</template>
}
